import { InventoryAdjustmentReasonDetailPage } from '@/features/inventory-adjustment-reason/pages/InventoryAdjustmentReasonDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/inventory-adjustment-reason/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["inventory_adjustment_reason.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: InventoryAdjustmentReasonDetailPage,
})
